import { createAction, handleActions } from 'redux-actions'

const setSearch = createAction('SCREENS/SUB_PROJECT/SUB_INVOICES/SET_SEARCH')
const resetSearch = createAction('SCREENS/SUB_PROJECT/SUB_INVOICES/RESET_SEARCH')

const defaultState = ''

const reducer = handleActions(
  {
    [setSearch]: (state, { payload }) => payload,
    [resetSearch]: () => defaultState,
  },
  defaultState,
)

export { setSearch, resetSearch, reducer }
